import Marionette from 'backbone.marionette';
import memberContributorsCollectionviewTmpl from '../templates/member_contributors_compositview.tpl';
import MemberContributorsItemview from './member_contributors_itemview';
export default Marionette.CompositeView.extend({
  template: memberContributorsCollectionviewTmpl,
  childView: MemberContributorsItemview,
  tagName: 'table',
  className: "table table-hover table-sm",
  childViewContainer: "tbody",
  id: "top-contributors-table"

  /*
  onShow: function() {
    $("#top-contributors-table").dataTable({
      bSort: true,
      pagingType: 'simple',
      responsive: true,
      order: [[4, 'desc'], [1, 'asc']],
      autoWidth: false, // you must set this to override the collumn width
      columns: [
        {
          // John thinks this had something to do with table sorting, but we don't need it anymore and it doesn't need to be displayed.
          // However, if it is removed from the data the column indexes will need to be udpated accordingly
          data: "contribution_ranking",
          visible: false
        }, {
          data: "contributor_name"
        }, {
          data: "business_name"
        }, {
          data: "total_contribution_records",
          className: "text-end"
        }, {
          data: "total_dollars",
          render: $.fn.dataTable.render.number( ',', '.', 0, '$' ),
          className: "text-end"
        }, {
          data: "percent_of_total_dollars",
          className: "text-end"
        }
      ],
      columnDefs: [
        //{ width: "160px", targets: 1 }, // otherwise it only shows first col in smallest size // doesn't appear to be the case anymore
        { responsivePriority: 1, targets: [1, 4] }, // (I think this is what shows on iPhone 4) contributor, total amount 
        { responsivePriority: 2, targets: [1, 2, 4] }, // (should show on all other phones) contributor, business type, total amount 
        { responsivePriority: 3, targets: [1, 2, 4, 5] }, // (tablets) contributor, business type, $total, percent of total
        { responsivePriority: 4, targets: [1, 2, 3, 4, 5] }, // contributor, business type, # contributions, $total, percent of total
        
      ],
      "footerCallback": function ( row, data, start, end, display ) {
          var api = this.api(), data;
           // Remove the formatting to get integer data for summation
          var intVal = function ( i ) {
              return typeof i === 'string' ?
                  i.replace(/[\$,]/g, '')*1 :
                  typeof i === 'number' ?
                      i : 0;
          };
           // Total over all pages
          var total = api
              .column( 4 )
              .data()
              .reduce( function (a, b) {
                  return intVal(a) + intVal(b);
              }, 0 );
           // Update footer
          $( api.column( 4 ).footer() ).html(
             $.fn.dataTable.render.number(',', '.', 0, '$').display(total)
          );
      }
    });
  }
  */
});